import { render, staticRenderFns } from "./LinkValidation.vue?vue&type=template&id=95abd69c&scoped=true&"
import script from "./LinkValidation.vue?vue&type=script&lang=js&"
export * from "./LinkValidation.vue?vue&type=script&lang=js&"
import style0 from "./LinkValidation.vue?vue&type=style&index=0&id=95abd69c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95abd69c",
  null
  
)

export default component.exports